import React from 'react';
import OnBoardingSections from '../../components/PTGC/onboarding/index';  // ✅ Fix import

const OnBoardingPage = () => {
  return (
    <>
      <OnBoardingSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default OnBoardingPage;